/**
 * Teacher API endpoints
 */

import apiClient from "../apiClient";

/**
 * Send business form email
 */
export const sendBusinessFormEmail = async (payload: {
  email: string;
  answers: string[];
  title: string;
}): Promise<void> => {
  await apiClient.post("/teacher/send/mail", payload, { skipAuth: true });
};
